import {connect} from "react-redux";
import {fetchSession} from "../middleware/loginActions";
import Header from "../components/Header";
import {GenericThunkDispatch} from "../types/Types";

const mapDispatchToProps = (dispatch: GenericThunkDispatch) => {
  return {
    fetchSession: () => {
      dispatch(fetchSession());
    }
  }
};


export default connect( null, mapDispatchToProps)(Header);
